import React from 'react';
import { Box, Typography } from '@mui/material';

export default function ScrollIndicator() {
  return (
    <Box sx={{
      position: 'absolute',
      bottom: { xs: 52, md: 48 },
      right: { xs: 20, md: 44 },
      zIndex: 3,
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
    }}>
      <Typography sx={{
        fontFamily: "'Outfit', sans-serif",
        fontWeight: 600,
        fontSize: '0.58rem',
        letterSpacing: '0.28em',
        color: 'rgba(255,255,255,0.50)',
        textTransform: 'uppercase',
        lineHeight: 1,
      }}>
        SCROLL
      </Typography>
      <Box sx={{
        position: 'relative',
        width: '1.5px',
        height: 52,
        background: 'rgba(255,255,255,0.15)',
        borderRadius: 2,
        overflow: 'hidden',
      }}>
        <Box sx={{
          position: 'absolute',
          top: 0, left: 0,
          width: '100%',
          height: '55%',
          background: 'linear-gradient(180deg, rgba(255,255,255,0.80) 0%, rgba(255,255,255,0.0) 100%)',
          borderRadius: 2,
          animation: 'scrollLine 1.8s cubic-bezier(0.4, 0, 0.6, 1) infinite',
          '@keyframes scrollLine': {
            '0%':   { transform: 'translateY(-100%)', opacity: 0 },
            '20%':  { opacity: 1 },
            '80%':  { opacity: 1 },
            '100%': { transform: 'translateY(200%)', opacity: 0 },
          },
        }} />
      </Box>
    </Box>
  );
}
